export default "__VITE_ASSET__K5HCWyG1__"